export default __webpack_public_path__ + "d83f01c864ac204fbb6e32b3386a9f2a.webp";